<template>
  <p class="l-back-top bg-white txt-c" @click="goTop">
    <span class="icon icon-top f20 c-333"></span>
  </p>
</template>

<script>
  import { scrollTop } from '../../libs/util';

  export default {
    data() {
      return {};
    },
    methods: {
      goTop() {
        const sTop = document.documentElement.scrollTop || document.body.scrollTop;
        let I = navigator.userAgent;
        let isAndroid = !!(I.match(/android/i));
        if (!isAndroid) {
          if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
            window.scrollTo(0, 0);
          } else {
            scrollTop(window, sTop, 0, 1000);
          }
        } else {
          scrollTop(window, sTop, 0, 1000);
        }
      }
    }
  };
</script>
